// Declare the Extension Method
function capitaliseFirstLetter(this: string): string {
    //return this[0].toUpperCase() + this.slice(1).toLowerCase();
    return this[0].toUpperCase() + this.slice(1);
}

// Declare the Extension
declare global {
    interface String {
        capitaliseFirstLetter(): string;
    }
}

// Implement the Extension
String.prototype.capitaliseFirstLetter = capitaliseFirstLetter;

export {}; // Ensures this file is treated as a module
